import activityTypes from './activityTypes/reducer'
import auth from './auth/reducer'
import ads from './ads/reducer'
import courses from './courses/reducer'
import { reducer as form } from 'redux-form'
import feed from './feed/reducer'
import friends from './friends/reducer'
import goals from './goals/reducer'
import notifications from './notifications/reducer'
import premium from './premium/reducer'
import paginator from './paginator/reducer'
import routes from './routes/reducer'
import site from './site/reducer'
import migration from './migration/reducer'
import user from './user/reducer'
import userGear from './userGear/reducer'
import userStats from './userStats/reducer'
import workouts from './workouts/reducer'
import yearInReview from './yearInReview/reducer'
import consents from './consents/reducer'
import { routeReducer } from 'react-router-redux'

export const identity = (state = {}) => state

export default {
  activityTypes,
  auth,
  ads,
  courses,
  // bootup is a special state object that shouldn't change
  // it's a snapshot of initialization data needed to
  // boot up the app
  bootup: identity,
  feed,
  form,
  friends,
  goals,
  notifications,
  paginator,
  premium,
  routes,
  routing: routeReducer,
  site,
  user,
  userGear,
  migration,
  userStats,
  workouts,
  yearInReview,
  consents,
}



// WEBPACK FOOTER //
// ./src/services/rootReducer.js